// Proppe — UI helpers
// Small DOM utilities used across the app.

/**
 * Show a toast notification.
 * @param {string} message
 * @param {'info'|'success'|'error'|'warning'} [type='info']
 * @param {number} [duration=3000] - ms before auto-dismiss
 */
export function toast(message, type = 'info', duration = 3000) {
  // Remove any existing toast
  const existing = document.querySelector('.toast');
  if (existing) existing.remove();

  const node = document.createElement('div');
  node.className = `toast ${type}`;
  node.textContent = message;
  document.body.appendChild(node);

  // Trigger fade-in on next frame
  requestAnimationFrame(() => node.classList.add('show'));

  // Auto-dismiss
  setTimeout(() => {
    node.classList.remove('show');
    setTimeout(() => node.remove(), 300);
  }, duration);
}

/**
 * Escape a string for safe HTML insertion (prevents XSS).
 * Always use this when building HTML strings from user/server data.
 */
export function esc(str) {
  if (str === null || str === undefined) return '';
  const div = document.createElement('div');
  div.textContent = String(str);
  return div.innerHTML;
}

/**
 * Tiny element creator. Beats document.createElement boilerplate.
 *
 * @example
 *   el('button', { class: 'btn btn-primary', onClick: handleClick }, 'Submit')
 */
export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'class') node.className = v;
    else if (k === 'html') node.innerHTML = v;
    else if (k.startsWith('on') && typeof v === 'function') {
      node.addEventListener(k.slice(2).toLowerCase(), v);
    } else if (v !== false && v != null) {
      node.setAttribute(k, v);
    }
  }
  const list = Array.isArray(children) ? children : [children];
  for (const c of list) {
    if (c == null || c === false) continue;
    node.append(c);
  }
  return node;
}

/**
 * Query selector with a default container.
 */
export function $(selector, container = document) {
  return container.querySelector(selector);
}

/**
 * Query all.
 */
export function $$(selector, container = document) {
  return Array.from(container.querySelectorAll(selector));
}
